import { useLocation, useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

import { GetPastConferencesDataType } from '@/api/conference';
import { Donation, Forum, Gallery, Newsletter, Notice, Trend } from '@/api/notice';
import LineIcon from '@/components/Icon/lineIcon';
import { SPONSORSHIP_MENU_ANNUAL_DONATION } from '@/constants/sponsorship';

import * as S from './style';

interface ConferenceListProps {
	data: (Gallery | Notice | Forum | Newsletter | Trend | Donation | GetPastConferencesDataType)[];
	sort: string;
}

const PostList = ({ data, sort }: ConferenceListProps) => {
	const navigate = useNavigate();
	const location = useLocation();
	const params = location.state?.menu ?? '공지사항';
	const getDynamicField = (g: any, field: string) => g[`${sort}_${field}`] || ''; // 동적으로 필드 처리
	const handleGetPk = (pk: number | string) => {
		console.log(`sort: ${sort}`);
		if (sort === 'guide') {
			navigate(`/conference/detail/${pk}`, { state: { menu: params } });
			return;
		} else if (sort === 'notice') {
			navigate(`/information/notice/${pk}`, { state: { menu: params } });
			return;
		} else if (sort === 'forum') {
			navigate(`/information/community/${pk}`, { state: { menu: params } });
			return;
		} else if (sort === 'donation') {
			navigate(`/sponsorship/donation/${pk}`, { state: { menu: SPONSORSHIP_MENU_ANNUAL_DONATION } });
			return;
		}
	};
	return (
		<S.PostList>
			{data.map((item) => (
				<S.PostListItem key={getDynamicField(item, 'pk')} onClick={() => handleGetPk(getDynamicField(item, 'pk'))}>
					<div className="title">{getDynamicField(item, 'title')}</div>
					<div className="sub_title">
						{getDynamicField(item, 'enrollment_date') === '' ? '-' : dayjs(getDynamicField(item, 'enrollment_date')).format('YYYY-MM-DD')}
						<LineIcon />
						조회수: {getDynamicField(item, 'hit') === '' ? '0' : getDynamicField(item, 'hit')}
					</div>
				</S.PostListItem>
			))}
		</S.PostList>
	);
};

export default PostList;
